import { render, staticRenderFns } from "./RegisterSocialComponent.vue?vue&type=template&id=42d89296&scoped=true"
import script from "./RegisterSocialComponent.vue?vue&type=script&lang=js"
export * from "./RegisterSocialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d89296",
  null
  
)

export default component.exports